var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V171.994H0V-0.00585938Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 171.994H513V343.994H0V171.994Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.4 251.494L270.7 237.694L159.9 251.494V85.3942H381.4V251.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.7 237.694C301.297 237.694 326.1 212.891 326.1 182.294C326.1 151.698 301.297 126.894 270.7 126.894C240.103 126.894 215.3 151.698 215.3 182.294C215.3 212.891 240.103 237.694 270.7 237.694Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.7 209.994C285.998 209.994 298.4 197.592 298.4 182.294C298.4 166.996 285.998 154.594 270.7 154.594C255.402 154.594 243 166.996 243 182.294C243 197.592 255.402 209.994 270.7 209.994Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.1 113.094H312.2L270.7 154.594L229.1 113.094Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.8 140.794H284.5V223.794H256.8V140.794Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.9 215.494H226.4L159.9 251.494H381.4L314.9 215.494Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHt);
export default __webpack_public_path__ + "static/media/HT.35f2573b5164eafa1af29fb2fc65461e.svg";
export { ForwardRef as ReactComponent };